import styled from 'styled-components';
import { H1, SectionParent } from '../../StyledComponents';

import React from 'react';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #1b2341;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  z-index: 2;
  position: relative;
  padding-top: 5rem !important;
  text-align: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const HeroTitle = styled(H1)`
  margin-left: 2.5rem;
  color: #fff;

  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin: auto;
  max-width: 70rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #fff;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
    margin-right: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

export default () => (
  <SectionOne id="section-one-kiosk">
    <HeroTitle>Who We Are</HeroTitle>
    <HeroSubTitle style={{ paddingTop: '1rem' }}>
      We are developers, Android geeks, and savvy innovators who love what we do
      - helping change the world with a full-stack Android device fleet
      platform. We have a global team of brilliant engineers, developers,
      designers and marketers who are dedicated to delivering innovative
      end-to-end technologies for Android devices. Esper is all about customer
      obsession, rapid iteration, and a great attitude with fun, respect, and
      helping the team win together.
    </HeroSubTitle>
  </SectionOne>
);
